import { API_URL } from "../Config/index.js";
import { emitEvent } from "../MasterData/emitter";

// Helper function to get auth token from localStorage
const getAuthToken = () => {
  // return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1aWQwNyIsImNsaWVudElkIjoiNDczOTIwOSIsInN0YWZmRnVsbE5hbWUiOiJTdXBlckFkbWluIiwicm9sZU5hbWUiOiJBZG1pbiIsInVzZXJQcm9kdWN0Ijp7InNob3dBcHBJY29uIjp0cnVlLCJhcHBzIjp7ImluY2lkZW50Ijp7InBlcm1pc3Npb24iOiJ3cml0ZSIsInVybCI6Imh0dHBzOi8vd3d3LnN1cHBvcnQtY2VudHJlLm9ydWNsaWNrcy5jb20vZGFzaGJvYXJkIn0sImNvbnRhY3RzIjp7InBlcm1pc3Npb24iOiJyZWFkIiwidXJsIjoiaHR0cHM6Ly93d3cuY29udGFjdHMub3J1Y2xpY2tzLmNvbS9kYXNoYm9hcmQifSwibGVhZCI6eyJwZXJtaXNzaW9uIjoicmVhZCIsInVybCI6Imh0dHBzOi8vd3d3LmxlYWQub3J1Y2xpY2tzLmNvbS9kYXNoYm9hcmQifSwiYmlsbGluZyI6eyJwZXJtaXNzaW9uIjoid3JpdGUiLCJ1cmwiOiJodHRwczovL3d3dy5iaWxsaW5nLm9ydWNsaWNrcy5jb20vZGFzaGJvYXJkIn19fSwidXNlclN0YXR1cyI6IkFjdGl2ZSIsImlhdCI6MTc3MTY3NTI0MSwiZXhwIjoxNzcxNjgyNDQxfQ.oYuS-nRplutukC8rLddPdqzuTZ47CPHz-bb8bK93-J4";
  return localStorage.getItem("authToken");
};

const handleSessionTimeout = (status, data) => {
  if (status === 401 && data?.sessionTimeout) {
    emitEvent("session-timeout", data);
    return true;
  }
  return false;
};


// Update Contact API
export const updateContact = async (clientId, dateTimeStamp, incidentStatus, replyMessage = null) => {
  try {
    const authToken = getAuthToken();
  
    let clientIdToUse = clientId;

    const requestBody = {
      clientId: clientIdToUse,
      dateTimeStamp: dateTimeStamp,
      incidentStatus: incidentStatus,
    };

    // Add replyMessage only if provided
    if (replyMessage) {
      requestBody.replyMessage = replyMessage;
    }

    const response = await fetch(`${API_URL}/support-centre/${clientIdToUse}/${dateTimeStamp}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `${authToken}` } : {}),
      },
      body: JSON.stringify(requestBody),
    });

    const result = await response.json().catch(() => ({}));

    console.log("PATCH API Response:", result);

    if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        data: null,
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (response.ok && result.status) {
      return {
        success: true,
        data: result.data,
        message: result.message || "Status updated successfully",
      };
    } else {
      return {
        success: false,
        data: null,
        message: result.message || "Failed to update status",
      };
    }
  } catch (error) {
    console.error("Error updating incident status:", error);
    return {
      success: false,
      data: null,
      message: error.message || "Network error occurred",
    };
  }
};

// Create Contact API
export const createContact = async (country, contactData) => {
  try {
    const authToken = getAuthToken();
    // const clientId = getClientId();

    if (!country) {
      return {
        success: false,
        data: null,
        message: "Country not found. Please log in again.",
      };
    }

    const response = await fetch(`${API_URL}/contacts/${country}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `${authToken}` } : {}),
      },
      body: JSON.stringify(contactData),
    });

    const result = await response.json().catch(() => ({}));

    if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        data: null,
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (response.ok && result.status) {
      return {
        success: true,
        data: result.data,
        message: result.message || "Incident created successfully",
      };
    } else {
      return {
        success: false,
        data: null,
        message: result.message || "Failed to create incident",
      };
    }
  } catch (error) {
    console.error("Error creating support incident:", error);
    return {
      success: false,
      data: null,
      message: error.message || "Network error occurred",
    };
  }
};

// Load Contacts by Country and Month/Year API
export const loadContacts = async (country, monthYear) => {
  try {
    const authToken = getAuthToken();
    
    // Fetch all contacts or filter by country
    const apiUrl = `${API_URL}/contacts/${country}/${monthYear}`;

    console.log("Fetching contacts");
    console.log("API URL:", apiUrl);
    console.log("Country filter:", country);
    console.log("Month/Year:", monthYear);

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `${authToken}` } : {}),
      },
    });

    const result = await response.json().catch(() => ({}));

    console.log("API Response Status:", response.status);
    console.log("API Response Data:", result);

    if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        data: [],
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (response.ok && result.status) {
      console.log("Success: Returning contacts data", result.data);
      return {
        success: true,
        data: result.data || [],
        count: result.count || result.data?.length || 0,
        message: result.message || "Contacts fetched successfully",
      };
    } else {
      return {
        success: false,
        data: [],
        message: result.message || "Failed to fetch contacts",
      };
    }
  } catch (error) {
    console.error("Error fetching contacts:", error);
    return {
      success: false,
      data: [],
      message: error.message || "Network error occurred",
    };
  }
};

// Update Lead API
export const updateLead = async (leadData) => {
  try {
    const authToken = getAuthToken();
    
    const apiUrl = `https://97ny4m4be2.execute-api.ap-south-1.amazonaws.com/LiveMode/manage-leads/updateLead`;

    console.log("Updating lead with data:", leadData);
    console.log("API URL:", apiUrl);

    const response = await fetch(apiUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `${authToken}` } : {}),
      },
      body: JSON.stringify(leadData),
    });

    const result = await response.json().catch(() => ({}));

    console.log("API Response Status:", response.status);
    console.log("API Response Data:", result);

    if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (response.ok && result.status) {
      console.log("Success: Lead updated");
      return {
        success: true,
        data: result.data || leadData,
        message: result.message || result.uiMsg || "Lead updated successfully",
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to update lead",
      };
    }
  } catch (error) {
    console.error("Error updating lead:", error);
    return {
      success: false,
      message: error.message || "Network error occurred",
    };
  }
};

// Update Contact API
export const updateContactData = async (country, dateTimeStamp, contactData) => {
  try {
    const authToken = getAuthToken();

    if (!country || !dateTimeStamp) {
      return {
        success: false,
        data: null,
        message: "Country and dateTimeStamp are required.",
      };
    }

    const response = await fetch(`${API_URL}/contacts/${country}/${dateTimeStamp}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `${authToken}` } : {}),
      },
      body: JSON.stringify(contactData),
    });

    const result = await response.json().catch(() => ({}));

    console.log("PATCH Contact API Response:", result);

    if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        data: null,
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (response.ok && result.status) {
      return {
        success: true,
        data: result.data,
        message: result.message || "Contact updated successfully",
      };
    } else {
      return {
        success: false,
        data: null,
        message: result.message || "Failed to update contact",
      };
    }
  } catch (error) {
    console.error("Error updating contact:", error);
    return {
      success: false,
      data: null,
      message: error.message || "Network error occurred",
    };
  }
};

// Delete Contact API
export const deleteContact = async (country, dateTimeStamp) => {
  try {
    const authToken = getAuthToken();

    if (!country || !dateTimeStamp) {
      return {
        success: false,
        message: "Country and dateTimeStamp are required.",
      };
    }

    const response = await fetch(`${API_URL}/contacts/${country}/${dateTimeStamp}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `${authToken}` } : {}),
      },
    });

    const result = await response.json().catch(() => ({}));

    console.log("DELETE Contact API Response:", result);

    if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (response.ok && result.status) {
      return {
        success: true,
        message: result.message || "Contact deleted successfully",
      };
    } else {
      return {
        success: false,
        message: result.message || "Failed to delete contact",
      };
    }
  } catch (error) {
    console.error("Error deleting contact:", error);
    return {
      success: false,
      message: error.message || "Network error occurred",
    };
  }
};
